<topbar>
        <h1 topbar-title>Schedule</h1>
</topbar>

<div class="container-content">
    <div class="content">
        <div class="wrapper">
           <div class="content-section">
            <div class="content-card">
                 <div
                            class="content-card__header content-card__header--blank">
                            <h3 class="content-card__heading">
                                Schedule Details
                            </h3>
                        </div>
                <div class="content-card__body">

                <stack pVertical pSize="small">

                    <form-field *ngIf="retrievedId.length === 0" pLabel="Location">
                        <mat-select
                            class="btn__select location-selector"
                            name="status"
                            [(ngModel)]="locationSelected"
                        >
                            <mat-option
                                [value]="location"
                                *ngFor="let location of locations"
                            >
                                {{ location }}
                            </mat-option>
                        </mat-select>
                    </form-field>

                    <form-field *ngIf="retrievedId.length !== 0" pLabel="Location">
                        <label>{{locationSelected}}</label>
                    </form-field>

                    <form-field pLabel="Scheduled Days">

                        <span class="checkbox-row-item" *ngFor="let d of days">
                            <input type="checkbox" [(ngModel)]="d.checked"> {{ d.name }}
                        </span>

                    </form-field>

                    <form-field pLabel="Exceptions">
                        
                        <div class="field-wrapper">
                            <div *ngFor="let date of sortedExceptionDates; let i = index">
                                {{date.displayedValue}}  <button class="btn" (click)="deleteDateByIndex(i)">Delete</button>
                            </div>
                            <custom-date-time-picker
                                name="exception_date"
                                id="exception_date"
                                [(ngModel)]="selectedExceptionDate"
                                hideTimePicker="true"
                            ></custom-date-time-picker>

                            <button class="btn" (click)="addExceptionDate()">Add Exception</button>
                        </div>
                    
                    </form-field>


                </stack>
                <button [disabled]="!canSubmit" (click)="submitSchedule()" class="btn btn--primary submission-button">{{title}}</button>
                </div>
            </div>
           </div>
        </div>
    </div>
</div>